import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import 'antd/dist/antd.css';
import { Steps, Col, Row, Typography, Space } from 'antd';
import {
  SolutionOutlined,
  EditOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
  AuditOutlined,
  ContainerOutlined,
  ExceptionOutlined,
  WarningOutlined
} from '@ant-design/icons';
import { STATES, ROLES, ACTIONS } from '../../config/constants/contractStates';
import time from '../../helpers/date';
import PropTypes from 'prop-types';

const { formatString } = time;

const { Title, Text } = Typography;
const { Step } = Steps;

/**
 * Component that returns a Steps with document history.
 * @component
 * @returns {Element} Steps with document interactions
 */
const DocumentHistory = ({ contract }) => {

  const [steps, setSteps] = useState([]);

  const StepComponent = ({ text, spanClass, role, date }) => (
    <Space direction='vertical'>
      <Text>{text}</Text>
      <span className={spanClass}>{role}</span>
      <Text>
        <CalendarOutlined />{formatString(date)}
      </Text>
    </Space>
  );

  const docData = [];

  useEffect(() => {
    if (contract.estado !== undefined) {
      pushObjData(contract);
    }
  }, [contract]);

  const addHistoryStep = (status, issuer, date) => {
    const step = new Object();
    switch (status) {
      case STATES.CREATED:
        step.title = <Title level={5}>Creado</Title>;
        step.content = <StepComponent
          text={`Se ha iniciado un proceso de creación por ${issuer}`}
          spanClass={['Sistema', 'Administrador'].includes(issuer) ? 'badge badge-danger' : 'badge badge-primary'}
          role={['Sistema', 'Administrador'].includes(issuer) ? issuer : 'Propietario'}
          date={date}
        />;
        step.icon = <SolutionOutlined />;
        docData.push(step);
        break;
      case ACTIONS.ADMIN_EDIT_PDF:
        step.title = <Title level={5}>PDF Editado</Title>;
        step.content = <StepComponent
          text={`El contrato ha sido editado manualmente por ${issuer}`}
          spanClass={'badge badge-danger'}
          role='Administrador'
          date={date}
        />;
        step.icon = <WarningOutlined />;
        docData.push(step);
        break;
      case ACTIONS.LESSOR_VALIDATE:
        step.title = <Title level={5}>Validado</Title>;
        step.content = <StepComponent
          text={`El contrato ha sido validado por ${issuer}`}
          spanClass={'badge badge-success'}
          role='Arrendador'
          date={date}
        />;
        step.icon = <EditOutlined />;
        docData.push(step);
        break;
      case ACTIONS.LESSEE_VALIDATE:
        step.title = <Title level={5}>Validado</Title>;
        step.content = <StepComponent
          text={`El contrato ha sido validado por ${issuer}`}
          spanClass={'badge badge-purple'}
          role='Arrendatario'
          date={date}
        />;
        step.icon = <EditOutlined />;
        docData.push(step);
        break;
      case ACTIONS.CODEBTOR_VALIDATE:
        step.title = <Title level={5}>Validado</Title>;
        step.content = <StepComponent
          text={`El contrato ha sido validado por ${issuer}`}
          spanClass={'badge badge-warning'}
          role='Codeudor'
          date={date}
        />;
        step.icon = <EditOutlined />;
        docData.push(step);
        break;
      case ACTIONS.LESSOR_SIGN:
        step.title = <Title level={5}>Firmado</Title>;
        step.content = <StepComponent
          text={`El contrato ha sido firmado por ${issuer}`}
          spanClass={'badge badge-success'}
          role='Arrendador'
          date={date}
        />;
        step.icon = <EditOutlined />;
        docData.push(step);
        break;
      case ACTIONS.LESSEE_SIGN:
        step.title = <Title level={5}>Firmado</Title>;
        step.content = <StepComponent
          text={`El contrato ha sido firmado por ${issuer}`}
          spanClass={'badge badge-purple'}
          role='Arrendatario'
          date={date}
        />;
        step.icon = <EditOutlined />;
        docData.push(step);
        break;
      case ACTIONS.CODEBTOR_SIGN:
        step.title = <Title level={5}>Firmado</Title>;
        step.content = <StepComponent
          text={`El contrato ha sido firmado por ${issuer}`}
          spanClass={'badge badge-warning'}
          role='Codeudor'
          date={date}
        />;
        step.icon = <EditOutlined />;
        docData.push(step);
        break;
      case STATES.AWAITING_NOTARY:
        step.title = <Title level={5}>En Notarisa</Title>;
        step.content = <StepComponent
          text={'El contrato ha sido enviado a NOTARISA'}
          spanClass={'badge badge-light'}
          role='Notarisa'
          date={date}
        />;
        step.icon = <AuditOutlined />;
        docData.push(step);
        break;
      case STATES.APPEALED:
        step.title = <Title level={5}>En espera de evidencia</Title>;
        step.content = <StepComponent
          text={'El contrato esta en espera de evidencia'}
          spanClass={'badge badge-warning'}
          role='Notarisa'
          date={date}
        />;
        step.icon = <WarningOutlined />;
        docData.push(step);
        break;
      case ACTIONS.LESSEE_OBJECT:
        step.title = <Title level={5}>Objetado</Title>;
        step.content = <StepComponent
          text={`El contrato ha sido objetado por ${issuer}`}
          spanClass={'badge badge-purple'}
          role='Arrendatario'
          date={date}
        />;
        step.icon = <ExceptionOutlined />;
        docData.push(step);
        break;
      case ACTIONS.LESSOR_OBJECT:
        step.title = <Title level={5}>Objetado</Title>;
        step.content = <StepComponent
          text={`El contrato ha sido objetado por ${issuer}`}
          spanClass={'badge badge-success'}
          role='Arrendador'
          date={date}
        />;
        step.icon = <ExceptionOutlined />;
        docData.push(step);
        break;
      case ACTIONS.CODEBTOR_OBJECT:
        step.title = <Title level={5}>Objetado</Title>;
        step.content = <StepComponent
          text={`El contrato ha sido objetado por ${issuer}`}
          spanClass={'badge badge-warning'}
          role='Codeudor'
          date={date}
        />;
        step.icon = <ExceptionOutlined />;
        docData.push(step);
        break;
      case ACTIONS.ADMIN_OBJECT:
        step.title = <Title level={5}>Objetado</Title>;
        step.content = <StepComponent
          text={`El contrato ha sido objetado por ${issuer}`}
          spanClass={'badge badge-danger'}
          role='Administrador'
          date={date}
        />;
        step.icon = <ExceptionOutlined />;
        docData.push(step);
        break;
      case STATES.SENDED:
        step.title = <Title level={5}>Enviado a firmar</Title>;
        step.content = <StepComponent
          text={'El contrato está listo para ser firmado'}
          spanClass={'badge badge-danger'}
          role='Administrador'
          date={date}
        />;
        step.icon = <ContainerOutlined />;
        docData.push(step);
        break;
      case STATES.FINALIZED:
        step.title = <Title level={5}>Finalizado</Title>;
        step.content = <StepComponent
          text={'El contrato ha sido notarizado'}
          spanClass={'badge badge-light'}
          role='Notarisa'
          date={date}
        />;
        step.icon = <CheckCircleOutlined />;
        docData.push(step);
        break;
      default:
        break;
    }
  };

  const pushObjData = contract => {
    if (contract.history[0]) {
      contract.history.map((doc) => {
        if (doc.status === STATES.CREATED || doc.status === STATES.SENDED || doc.status === STATES.CANCELED || doc.status === STATES.FINALIZED) {
          if (doc.issuer === 'system') { doc.issuer = 'Sistema'; }
          addHistoryStep(doc.status, doc.issuer, doc.date);
        };
        if (doc.status === STATES.AWAITING_VALIDATION || doc.status === STATES.VALIDATE_BY_ALL) {
          if (doc.role === ROLES.LESSOR) {
            addHistoryStep(ACTIONS.LESSOR_VALIDATE, doc.issuer, doc.date);
          };
          if ([ROLES.LESSEE, ROLES.LESSEES].includes(doc.role)) {
            addHistoryStep(ACTIONS.LESSEE_VALIDATE, doc.issuer, doc.date);
          };
          if ([ROLES.CODEBTOR, ROLES.CODEBTORS].includes(doc.role)) {
            addHistoryStep(ACTIONS.CODEBTOR_VALIDATE, doc.issuer, doc.date);
          };
        };
        if (doc.status === STATES.AWAITING_SIGN) {
          if (doc.role === ROLES.LESSOR) {
            addHistoryStep(ACTIONS.LESSOR_SIGN, doc.issuer, doc.date);
          };
          if (doc.role === ROLES.LESSEE) {
            addHistoryStep(ACTIONS.LESSEE_SIGN, doc.issuer, doc.date);
          };
          if (doc.role === ROLES.CODEBTOR) {
            addHistoryStep(ACTIONS.CODEBTOR_SIGN, doc.issuer, doc.date);
          };
        };
        if (doc.status === STATES.AWAITING_NOTARY) {
          addHistoryStep(doc.status, doc.issuer, doc.date);
        };
        if (doc.status === STATES.APPEALED) {
          addHistoryStep(doc.status, doc.issuer, doc.date);
        };
        if (doc.status === STATES.OBJECTED) {
          if (doc.role === ROLES.LESSOR) {
            addHistoryStep(ACTIONS.LESSOR_OBJECT, doc.issuer, doc.date);
          };
          if ([ROLES.LESSEE, ROLES.LESSEES].includes(doc.role)) {
            addHistoryStep(ACTIONS.LESSEE_OBJECT, doc.issuer, doc.date);
          };
          if ([ROLES.CODEBTOR, ROLES.CODEBTORS].includes(doc.role)) {
            addHistoryStep(ACTIONS.CODEBTOR_OBJECT, doc.issuer, doc.date);
          };
          if (doc.role === ROLES.ADMIN) {
            addHistoryStep(ACTIONS.ADMIN_OBJECT, doc.issuer, doc.date);
          };
        };
        if (doc.status === STATES.MODIFIED_PDF) {
          addHistoryStep(ACTIONS.ADMIN_EDIT_PDF, doc.issuer, doc.date);
        }
      });
    }
    setSteps(docData);
  };

  return (
    <>
      <Row>
        <Col span={24}>
          <Title level={3}>Estado de firmas</Title>
        </Col>
      </Row>
      <br />
      <Steps
        direction='vertical'
        current={steps.length}
        className='mb-4'
      >
        {steps.map((step, index) => (
          <Step
            key={index}
            icon={step.icon}
            title={step.title}
            description={step.content}
          ></Step>
        ))}
      </Steps>
    </>
  );
};

DocumentHistory.propTypes = {
  contract: PropTypes.object.isRequired,
  text: PropTypes.string,
  spanClass: PropTypes.string,
  role: PropTypes.string,
  date: PropTypes.string,
};

const data = (state) => ({
  contract: state.contract.contract,
});

export default connect(data, null)(DocumentHistory);